import React from "react";
import "./CoursePage.css";
import TallyBanner from "../Component/Slide 1.jpg";

const TallyPage = () => {
  return (
    <div className="course-page">
      {/* ===== Banner Section ===== */}
      <div className="course-banner">
        <img src={TallyBanner} alt="Tally" className="banner-img" />
      </div>

      {/* ===== Content Section ===== */}
      <div className="course-content">
        <h2>Tally Communication – Accounting and Business Communication</h2>

        <p className="course-text">
          The <strong>Tally Communication</strong> program at 
          <strong> Career Point of Information Technology (CPIT)</strong> is a 
          comprehensive training designed for students who want to develop 
          professional accounting and communication skills. This course is ideal 
          for individuals aiming for careers in accounting, finance, or business 
          administration.
        </p>

        <p className="course-text">
          The course focuses on <strong>Tally ERP</strong> — a powerful accounting 
          software widely used by businesses to manage financial transactions, 
          inventory, and payroll. Students learn to handle accounting vouchers, 
          balance sheets, ledgers, GST returns, and bank reconciliation with 
          real-world examples and simulations.
        </p>

        <p className="course-text">
          Alongside technical training, CPIT integrates <strong>business communication</strong> 
          modules to strengthen students’ interpersonal and professional skills. 
          These include spoken and written English, workplace etiquette, 
          email writing, and effective presentation techniques that prepare 
          learners for corporate environments.
        </p>

        <p className="course-text">
          The course also emphasizes <strong>practical accounting</strong> concepts 
          such as budgeting, taxation, cost analysis, and auditing. Learners are 
          guided through case studies and financial report creation, which enhance 
          their analytical thinking and problem-solving abilities.
        </p>

        <p className="course-text">
          With CPIT’s experienced faculty and industry-based curriculum, students 
          get exposure to modern accounting practices and professional reporting 
          standards. The course is structured to help learners become proficient 
          in both Tally operations and communication — two skills that are highly 
          valued in today’s job market.
        </p>

        <p className="course-text mb-0">
          After completing the <strong>Tally Communication</strong> course, 
          students can confidently pursue careers as <strong>Accounts Executives</strong>, 
          <strong> Billing Officers</strong>, <strong>Finance Assistants</strong>, or 
          <strong> Junior Auditors</strong>. This course not only ensures strong 
          accounting knowledge but also builds a confident and well-spoken 
          professional ready to succeed in any business environment.
        </p>
      </div>
    </div>
  );
};

export default TallyPage;
